import React, { useCallback, useState } from 'react';
import { ImageDataType } from '../../../types/ImageDataType';
import { AttachedImage } from './AttachedImage';
import { PLAZA_IMAGE_MAX_WIDTH, PLAZA_IMAGE_MAX_HEIGHT } from '../../../lib/constants';
import { ImageCropper } from '../../image-cropper';
import { AttachedVideo } from './AttachedVideo';


type CommentContentInputProps = {
  showCharacterCounter?: boolean,
  attachedImage?: ImageDataType,
  attachedAnimatedImg?: ImageDataType,
  disabled?: boolean,
  className?: string,
  onAttachedImageChange?: (image: ImageDataType) => any,
  onChangeAttachedImageRequest?: () => any
};

export function CommentContentInput({
  attachedImage,
  disabled,
  className,
  onAttachedImageChange,
  onChangeAttachedImageRequest,
}: CommentContentInputProps) {
  const [isCropperOpen, setIsCropperOpen] = useState<boolean>(false);

  const onImageLoadedCallback = useCallback((imageWidth: number, imageHeight: number) => {
    if (imageWidth > PLAZA_IMAGE_MAX_WIDTH || imageHeight > PLAZA_IMAGE_MAX_HEIGHT) {
      setIsCropperOpen(true);
    }
  }, []);


  const closeImageCropToolCallback = () => {
    onAttachedImageChange?.(null);
    setIsCropperOpen(false);
  };

  const cropImageCallback = (imageData: string) => {
      if (imageData) {
        onAttachedImageChange({
          ...attachedImage,
          croppedImage: imageData
        });
      }
      setIsCropperOpen(false);
  };

  return (
    <div className={`flex flex-col ${className || ''}`}>
      <div className="flex">

      {attachedImage && (
        <AttachedImage
          className="mt-4"
          imageData={attachedImage}
          disabled={disabled}
          onImageRemove={() => onAttachedImageChange?.(null)}
          onImageLoaded={onImageLoadedCallback} />
      )}
        
      <ImageCropper
        imageUrl={attachedImage ? URL.createObjectURL(attachedImage.imageFile) : null}
        isOpen={isCropperOpen}
        imageMaxWidth={PLAZA_IMAGE_MAX_WIDTH}
        imageMaxHeight={PLAZA_IMAGE_MAX_HEIGHT}
        onClose={closeImageCropToolCallback}
        onCrop={cropImageCallback}
        onChangeImage={onChangeAttachedImageRequest}
        />
    </div>
    </div>
  );
}